"use client";

// Dev-only "Sign in as Admin" shortcut.
//
// Renders the button ONLY when NODE_ENV === "development". The check
// runs at build time so the button + credentials never ship to prod.
// Clicking it calls signIn("credentials") with the seed admin's
// account and routes straight to /admin.
//
// If you change the seed admin's password in prisma/seed.ts, update
// the constant below too.

import { signIn } from "next-auth/react";
import { useState } from "react";
import { Shield, SpinnerGap } from "@phosphor-icons/react/dist/ssr";

const ADMIN_EMAIL = "babu@gate36.me";
const ADMIN_PASSWORD = "Admin!2026"; // matches prisma/seed.ts

export default function DevAdminLoginButton({
  callbackUrl = "/admin",
}: {
  /** Where to land after sign-in. Defaults to /admin so the home-page
   *  button drops you on the admin dashboard; the /login page passes
   *  through whatever ?callbackUrl was on its URL. */
  callbackUrl?: string;
} = {}) {
  const [busy, setBusy] = useState(false);

  // Don't even render in production — saves shipping the button label,
  // the credentials, and the icon import.
  if (process.env.NODE_ENV !== "development") return null;

  const onClick = async () => {
    setBusy(true);
    await signIn("credentials", {
      email: ADMIN_EMAIL,
      password: ADMIN_PASSWORD,
      callbackUrl,
    });
    // signIn() navigates on success; on failure the page reloads with
    // ?error= and the button rerenders fresh.
  };

  return (
    <button
      onClick={onClick}
      disabled={busy}
      className="inline-flex items-center gap-2 rounded-sm border border-amber-500/40 bg-amber-50 dark:bg-amber-950/30 px-3.5 py-2 text-sm font-medium text-amber-900 dark:text-amber-200 hover:bg-amber-100 dark:hover:bg-amber-950/50 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
      title="Dev convenience — only visible in development mode"
    >
      {busy ? (
        <SpinnerGap className="w-4 h-4 animate-spin" weight="bold" />
      ) : (
        <Shield className="w-4 h-4" weight="fill" />
      )}
      Dev Admin login
    </button>
  );
}
